import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { reactive, onMounted } from 'vue';
import headTabbar from './components/headTabbar';
import navigationbar from './components/navigationbar';
import headTabbarM from './components/headTabbarM';
import navigationbarM from './components/navigationbarM';
export default {
  __name: 'App',
  setup(__props) {
    const data = reactive({
      show: []
    });
    const ISMOBILE = function () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      console.log(flag, "11111111");
      return flag;
    };
    onMounted(() => {
      // 代码逻辑0
      data.show = ISMOBILE();
      console.log(data.show, ISMOBILE(), "9999");
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock(_Fragment, null, [data.show?.length == 0 || data.show?.length == null ? (_openBlock(), _createBlock(_unref(headTabbar), {
        key: 0,
        class: "headTab"
      })) : _createCommentVNode("", true), data.show?.length != 0 && data.show?.length != null ? (_openBlock(), _createBlock(_unref(headTabbarM), {
        key: 1,
        class: "headTab"
      })) : _createCommentVNode("", true), _createVNode(_component_router_view), data.show?.length == 0 || data.show?.length == null ? (_openBlock(), _createBlock(_unref(navigationbar), {
        key: 2,
        class: "headTab"
      })) : _createCommentVNode("", true), data.show?.length != 0 && data.show?.length != null ? (_openBlock(), _createBlock(_unref(navigationbarM), {
        key: 3,
        class: "headTab"
      })) : _createCommentVNode("", true)], 64);
    };
  }
};